import { Entity } from "gen/company/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { useMemo, useState } from "react"
import { UUID } from "shared-ts/classes/uuid"
import {
  useLocalSearchPopoverSelect,
  UseLocalSearchPopoverSelectRes,
} from "shared-web/components/composite/popover"

import { useListEntitiesForCompanyQuery } from "features/api/company"

interface UseEntitiesPopoverSelectProps {
  defaultSelectedId?: PBUUID
}

type UseEntitiesPopoverSelectRes = UseLocalSearchPopoverSelectRes<Entity>

function useEntitiesPopoverSelect({
  defaultSelectedId,
}: UseEntitiesPopoverSelectProps): UseEntitiesPopoverSelectRes {
  const { data } = useListEntitiesForCompanyQuery({})
  const [selected, setSelected] = useState<Entity | null>(null)

  const sortedEntities = useMemo(() => {
    const entities = data?.entities ?? []
    return [...entities].sort((a, b) => a.name.localeCompare(b.name))
  }, [data?.entities])

  const defaultSelected = useMemo(() => {
    if (!defaultSelectedId) {
      return undefined
    }
    return sortedEntities.find((e) => UUID.eqFromPB(e.id, defaultSelectedId))
  }, [defaultSelectedId, sortedEntities])

  return useLocalSearchPopoverSelect({
    items: sortedEntities,
    keyExtractor,
    labelExtractor,
    selected: selected ?? defaultSelected ?? null,
    onSelect: setSelected,
  })
}

function keyExtractor(entity: Entity): string {
  return UUID.idString(entity.id)
}

function labelExtractor(entity: Entity): string {
  return entity.name
}

export default useEntitiesPopoverSelect
